import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const SERVICES = [
  { slug: 'video', icon: '📹', title: 'Видеонаблюдение', desc: 'Более 300 систем с аналитикой, 4K, адаптация к морскому климату' },
  { slug: 'networks', icon: '🔌', title: 'Локальные сети', desc: 'СКС, ЛВС, ВОЛС, оптоволокно. Скорость до 100 Гбит/с' },
  { slug: 'wifi', icon: '📶', title: 'Wi-Fi и HotSpot', desc: 'Бесшовный WiFi, авторизация по звонку или ваучеру' },
  { slug: 'telephony', icon: '📞', title: 'Телефония', desc: 'IP-АТС, 8-800, интеграция с CRM. Более 100 внедрений' },
  { slug: 'tv', icon: '📺', title: 'Телевидение', desc: 'IP-TV, DVB-T2, гостиничные системы с управлением контентом' },
  { slug: 'servers', icon: '🖥️', title: 'Серверные комнаты', desc: 'Строительство ЦОД, стоек, ИБП, климат-контроль. Uptime 99.98%' },
  { slug: 'barrier', icon: '🚧', title: 'Умный шлагбаум', desc: 'Распознавание номеров (99.7%), ваучеры, мобильное приложение' },
  { slug: 'equipment', icon: '⚙️', title: 'Подбор оборудования', desc: 'Поставка и настройка Cisco, Hikvision, Dahua, Ubiquiti' },
  { slug: 'automation', icon: '🔄', title: 'Автоматизация процессов', desc: 'Умный дом, промышленность, освещение, отопление. Экономия до 40%' },
  { slug: 'access', icon: '🔐', title: 'Контроль доступа', desc: 'Домофоны, СКУД, биометрия, интеграция с PMS для гостиниц' },
  { slug: 'workplaces', icon: '💼', title: 'Рабочие места', desc: 'Организация рабочих мест, периферия, ВКС' },
  { slug: 'hotel', icon: '🏨', title: 'Для гостиниц', desc: 'Комплексные решения: умные номера, телевидение, WiFi, шлагбаумы' }
];

const Home = () => {
  return (
    <div className="home">
      <section className="hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="hero-badge">Надёжные IT-решения с 2011 года</div>
          <h1>
            <span className="highlight">15 лет</span> создаём цифровую инфраструктуру
            <br />на Черноморском побережье
          </h1>
          <p className="hero-subtitle">
            От проектирования до обслуживания сложных IT-систем и слаботочных сетей
          </p>
          <div className="hero-stats">
            <div className="stat">
              <span className="stat-number">500+</span>
              <span className="stat-label">успешных проектов</span>
            </div>
            <div className="stat">
              <span className="stat-number">24/7</span>
              <span className="stat-label">поддержка</span>
            </div>
            <div className="stat">
              <span className="stat-number">15</span>
              <span className="stat-label">лет опыта</span>
            </div>
          </div>
          <div className="hero-actions">
            <a href="tel:88006006541" className="btn btn-primary">
              📞 8-800-600-65-41
            </a>
            <Link to="/contact" className="btn btn-secondary">
              Получить консультацию
            </Link>
          </div>
        </div>
      </section>

      <section className="specialization">
        <div className="container">
          <h2 className="section-title">Наша специализация</h2>
          <div className="spec-grid">
            <Link to="/services/hotel" className="spec-card spec-card-link">
              <div className="spec-icon">🏨</div>
              <h3>Гостиничные решения</h3>
              <p>Полный спектр для курортных отелей: умные номера, телевидение, WiFi, СКУД, шлагбаумы. Работаем от Анапы до Сочи.</p>
              <span className="card-link-label">Подробнее →</span>
            </Link>
            <Link to="/services/networks" className="spec-card spec-card-link">
              <div className="spec-icon">🌐</div>
              <h3>Сети и коммуникации</h3>
              <p>СКС, ЛВС, ВОЛС до 100 Гбит/с. Сварка оптоволокна, диагностика, аварийный ремонт в любых условиях.</p>
              <span className="card-link-label">Подробнее →</span>
            </Link>
            <Link to="/services/automation" className="spec-card spec-card-link">
              <div className="spec-icon">🏠</div>
              <h3>Автоматизация</h3>
              <p>Умный дом, промышленная автоматизация, энергосбережение до 40%. Проекты для заводов, виноделен и портов.</p>
              <span className="card-link-label">Подробнее →</span>
            </Link>
          </div>
        </div>
      </section>

      <section className="services">
        <div className="container">
          <h2 className="section-title">Все направления</h2>
          <div className="services-grid">
            {SERVICES.map((s) => (
              <Link key={s.slug} to={`/services/${s.slug}`} className="service-card service-card-link">
                <div className="service-icon">{s.icon}</div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
                <span className="card-link-label">Узнать больше →</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="advantages">
        <div className="container">
          <h2 className="section-title">Почему выбирают нас</h2>
          <div className="advantages-grid">
            <div className="advantage-card">
              <div className="advantage-number">01</div>
              <h3>Полный цикл работ</h3>
              <p>От проектирования до обслуживания. Единый подрядчик — экономим ваше время и бюджет.</p>
            </div>
            <div className="advantage-card">
              <div className="advantage-number">02</div>
              <h3>Опыт 15 лет</h3>
              <p>С 2011 года мы накопили уникальный опыт работы в условиях курортного региона (повышенная влажность, солёный воздух).</p>
            </div>
            <div className="advantage-card">
              <div className="advantage-number">03</div>
              <h3>Собственная сервисная служба</h3>
              <p>Аварийный ремонт в течение 2‑х часов в Новороссийске и пригороде, поддержка 24/7.</p>
            </div>
            <div className="advantage-card">
              <div className="advantage-number">04</div>
              <h3>Комплексные решения</h3>
              <p>Интеграция видеонаблюдения, СКУД, Wi-Fi, телефонии в единую экосистему.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Готовы обсудить ваш проект?</h2>
            <p>Работаем на Черноморском побережье от Анапы до Сочи. Свяжитесь с нами для бесплатной консультации.</p>
            <div className="cta-contacts">
              <a href="tel:88006006541" className="cta-phone">📞 8-800-600-65-41</a>
              <a href="tel:88617654111" className="cta-phone">📞 8 (8617) 654-111</a>
              <a href="mailto:info@inet-sm.ru" className="cta-email">✉️ info@inet-sm.ru</a>
            </div>
            <Link to="/contact" className="btn btn-primary btn-large">Оставить заявку</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
